import { Component, Input } from '@angular/core';

@Component({
  selector: 'identity-validation-messages',
  templateUrl: './validation-messages.component.html'
})
export class IdentityValidationMessagesComponent {
  @Input() errorMessages: string[] | undefined;

}
